import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { ICardPropertiesHOCProps } from './types';
import { CardProperties } from '../../components/CardProperties/CardProperties';
import { ICardPropertiesEvents, ICardPropertiesFields } from '../../components/CardProperties/types';
import { onDefaultToggle } from './events/onDefaultToggle';
import { getPanelReadonly } from '../../../../selectors/getPanelReadonly';
import { onRequiredToggle } from './events/onRequiredToggle';
import { getCardPropertiesForSettingsCreateSelector } from './selectors/getCardPropertiesForSettings';
import { getAuthUser } from '../../../../../../../../store/model/authUser/selectors/getAuthUser';
import { onDisallowClick } from './events/onDisallowClick';
import { checkIfAllCardPropertiesAreDefault } from './selectors/checkIfAllCardPropertiesAreDefault';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';
import { getSectionType } from '../../../../selectors/getSectionType';
import { onPreviewToggle } from './events/onPreviewToggle';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../effects/showBoardLimitSnackbarIfNeeded';

const mapStateToProps = () => {
    const getCardPropertiesForSettings = getCardPropertiesForSettingsCreateSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        { boardId, type }: ICardPropertiesHOCProps
    ): ICardPropertiesFields => {
        const authUser = getAuthUser(state);
        const cardProperties = getCardPropertiesForSettings(state, boardId, type);
        const areAllDefault = checkIfAllCardPropertiesAreDefault(cardProperties);
        const sectionType = getSectionType(state, boardId, null, 'allowBackupXml', 'allowCreateBackUp');
        return {
            areAllDefault,
            cardProperties,
            isAdmin: sectionType !== ESettingsSectionType.DISALLOW && sectionType !== ESettingsSectionType.READONLY,
            isReadonly: getPanelReadonly(state, boardId, null, null, 'allowEditCardDetailSettings'),
            isDisallow: authUser && !authUser.allowRequiredProperties
        }
    };

    return _mapStateToProps;
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: ICardPropertiesHOCProps
): ICardPropertiesEvents => {
    const { boardId } = ownProps;
    return {
        onDefaultToggle: (key, name) => dispatch(onDefaultToggle(boardId, key, name)),
        onPreviewToggle: (key, name) => dispatch(onPreviewToggle(boardId, key, name)),
        onShowBoardLimitSnackbarIfNeeded: () => dispatch(showBoardLimitSnackbarIfNeeded()),
        onRequiredToggle: (key, name) => dispatch(onRequiredToggle(boardId, key, name)),
        onDisallowClick: () => dispatch(onDisallowClick())
    }
};

export const CardPropertiesHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardProperties);

CardPropertiesHOC.displayName = 'CardPropertiesHOC';
